module.exports = __webpack_public_path__ + "img/dcfl06.751f8b39.png";